import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeDollarSignIcon, ScrollTextIcon, SearchCheckIcon, UsersIcon, WrenchIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { company } from '../../data/company';
import { services } from '../../data/services';
import type { TranslationKey } from '../../data/translations';
const points: {
  icon: typeof SearchCheckIcon;
  title: TranslationKey;
  desc: TranslationKey;
}[] = [{
  icon: SearchCheckIcon,
  title: 'why.p1.title',
  desc: 'why.p1.desc'
}, {
  icon: WrenchIcon,
  title: 'why.p2.title',
  desc: 'why.p2.desc'
}, {
  icon: UsersIcon,
  title: 'why.p3.title',
  desc: 'why.p3.desc'
}, {
  icon: BadgeDollarSignIcon,
  title: 'why.p4.title',
  desc: 'why.p4.desc'
}, {
  icon: ScrollTextIcon,
  title: 'why.p5.title',
  desc: 'why.p5.desc'
}];
export function WhyChoose() {
  const {
    t,
    b
  } = useLanguage();
  return <section className="bg-white py-20 md:py-24" aria-labelledby="why-title" data-id="element-400" data-mp="4kj9g4gq4psy">
      <div className="mx-auto grid max-w-page items-start gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8" data-id="element-401" data-mp="22td3dwgkojok">
        <div className="grid gap-4 sm:grid-cols-2 lg:sticky lg:top-28" data-id="element-402" data-mp="27kmpwo6tr6w8">
          <img src={company.workImage} alt={t('about.workAlt')} loading="lazy" className="h-72 w-full rounded-lg object-cover sm:col-span-2 sm:h-80" width={900} height={600} data-id="element-403" data-mp="27lxvmtjtyopz" />
          <img src={services[1].image} alt={b(services[1].imageAlt)} loading="lazy" className="h-44 w-full rounded-lg object-cover" width={600} height={400} data-id="element-404" data-mp="2ll5uflc2zutn" />
          <img src={services[4].image} alt={b(services[4].imageAlt)} loading="lazy" className="h-44 w-full rounded-lg object-cover" width={600} height={400} data-id="element-405" data-mp="2cliqosvvqcxf" />
        </div>

        <div data-id="element-406" data-mp="163voqrzm3naq">
          <h2 id="why-title" className="font-display text-3xl font-bold leading-tight tracking-tight text-navy md:text-[2.4rem]" data-id="element-407" data-mp="164ovhsykmcsv">
            {t('why.title')}
          </h2>
          <p className="mt-4 text-lg text-ink-muted" data-id="element-408" data-mp="32tymaj4e1ld1">{t('why.intro')}</p>

          <ul className="mt-10 space-y-7" data-id="element-409" data-mp="2y15ka30b0r4n">
            {points.map(({
            icon: Icon,
            title,
            desc
          }) => <li key={title} className="flex gap-4" data-id="element-410" data-mp="2u03fl6nmbmva">
                <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-brand-50 text-brand-700" data-id="element-411" data-mp="2p1ijnjfefpcn">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-412" data-mp="2k1nubkb9v7tp" />
                </span>
                <div data-id="element-413" data-mp="2f2uehl8ij4qd">
                  <h3 className="font-display text-base font-bold text-navy" data-id="element-414" data-mp="2f44dccn6wgy2">{t(title)}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-ink-muted" data-id="element-415" data-mp="2b3c25durc1z5">{t(desc)}</p>
                </div>
              </li>)}
          </ul>

          <Link to="/#contact" className="mt-10 inline-flex items-center justify-center rounded-md bg-cta px-6 py-3.5 text-base font-bold text-white transition-colors duration-200 ease-smooth hover:bg-cta-dark" data-id="element-416" data-mp="9axd7utspx98">
            {t('cta.scheduleToday')}
          </Link>
        </div>
      </div>
    </section>;
}